export enum COOKIE_NAME {
  IS_AUTHENTICATED = 'is_authenticated',
  IS_REGISTERED = 'is_registered',
  ACTIVE_SESSION = 'active_session',
  STAG = 'stag',
}
